<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <v-text-field
          class="purple-input"
          label="Nome"
          messages="Nome artístico. Será utilizado na distribução de conteúdos em todas as plataformas digitais."
          v-model="artista.name"
        />
      </v-flex>
      <v-flex xs12 md12 v-if="artista.custom_name">
        <v-text-field
          class="purple-input"
          label="Nome"
          messages="Nome customizado. Enviado através da API."
          v-model="artista.custom_name"
          disabled
        />
      </v-flex>
     
        <v-flex xs6 md6 py-4>
          <v-switch
            :label="`Esse artista é representado por uma empresa?`"
            messages="Caso o artista tenha empresa é necessário marcar essa opção"
            v-model="artista.is_company"
          ></v-switch>
        </v-flex>

        <v-flex xs12 md12 v-if="artista.is_company">
          <v-text-field
          class="purple-input"
          label="Razão Social"
          messages="Digite a Razão Social da Empresa"
          v-model="artista.br_razao_social"            
        />
        </v-flex>

        <v-flex xs12 md12 v-if="artista.is_company">
            <v-text-field
            class="purple-input"
            label="Nome Fantasia"
            messages="Digite o nome fantasia da empresa"
            v-model="artista.br_nome_fantasia"            
          />
          </v-flex>

        <v-flex xs12 md12 v-if="artista.is_company">
           <v-text-field
          class="purple-input"
          label="CNPJ"
          messages="Digite o CNPJ da Empresa"
          v-model="artista.br_cnpj"
          
        />
        </v-flex>

        <v-flex xs12 md6 v-if="artista.is_company">
           <v-text-field
          class="purple-input"
          label="Banco"
          messages="Digite o nome do Banco"
          v-model="artista.bank_id"
          
        />
        </v-flex>

        <v-flex xs12 md3 v-if="artista.is_company">
           <v-text-field
          class="purple-input"
          label="Agência"
          messages="Digite a agência sem digito verificador"
          v-model="artista.bank_agency"          
        />
        </v-flex>
         <v-flex xs12 md3 v-if="artista.is_company">
           <v-text-field
          class="purple-input"
          label="Conta"
          messages="Digite a conta do seu banco com o digito verificador"
          v-model="artista.bank_account"          
        />
        </v-flex>
      

      <!--v-flex xs12 md12 pt-5>
        <v-btn color="primary" @click="salvar()">Salvar</v-btn>
      </v-flex-->
    </v-layout>
  </v-container>
</template>

<script>


export default {
  data: () => ({
    artista: {}   
  }),
  props:{
    artistdata: Object
  },  
  watch:{
    artista: function(){
      this.$emit('artist_data', this.artista)
    },
    artistdata:function(){
      this.artista = this.artistdata;
    }
  }
};
</script>


